import { render, staticRenderFns } from "./EmailMessage.vue?vue&type=template&id=5aa28c8b&scoped=true&"
import script from "./EmailMessage.vue?vue&type=script&lang=js&"
export * from "./EmailMessage.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessage.vue?vue&type=style&index=0&id=5aa28c8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa28c8b",
  null
  
)

export default component.exports